var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCharging = function SvgCharging(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 46,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 45.714v-7.143h5V4.286A4.286 4.286 0 0 1 9.286 0h22.857a4.286 4.286 0 0 1 4.286 4.286V38.57h5v7.143zm17.143-8.571L28.57 25H21.43l3.474-5.714h-6.017l-5.315 10H20zM30 6.429H11.429V15H30z"
  })));
};
export default SvgCharging;